module.exports = __webpack_public_path__ + "img/bv.7af9f1dd.svg";